function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#21BB3A",
  d: "M32.02 66c-1.806 0-3.614-.71-4.991-2.13L2.068 38.143c-2.757-2.841-2.757-7.447 0-10.29 2.757-2.84 7.227-2.84 9.984 0l19.968 20.58L76.948 2.131c2.758-2.84 7.228-2.842 9.983 0 2.759 2.841 2.759 7.449 0 10.29l-49.92 51.448C35.634 65.29 33.827 66 32.02 66z"
});

var SvgCheckCopy2 = function SvgCheckCopy2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 89,
    height: 66,
    viewBox: "0 0 89 66",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheckCopy2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-copy-2.d27a30fa.svg";
export { ForwardRef as ReactComponent };